import Api from "@/services/Api";
export default {
  getWarranties(params) {
    return Api().get("/api/warranties/", { params });
  },
  getWarranty(code) {
    return Api().get(`/api/warranties/${code}`);
  },
  getStats() {
    return Api().get("/api/warranties/stats");
  }
};
